import React, { Suspense, useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import OpenCartButton from './OpenCartButton';
import SignInButton from './SignInButton';
import { Link } from "react-router-dom";
import ConfigContext from '../../../contexts/ConfigContext';
import SearchField from './SearchField';

// Unified branding: header always shows The Back Room regardless of which
// tenant tab is active. The Grow Shop is now a section, not a separate brand.
const BRAND_NAME = 'The Back Room™';
const BRAND_LOGO_ROOT = 'The Back Room';

type Props = {
  setCartOpen: React.Dispatch<React.SetStateAction<boolean>>,
}

export default function PrimarySearchAppBar({ setCartOpen }: Props) {
  const {config} = useContext(ConfigContext);

  const openCartDrawer = (event: React.MouseEvent<HTMLElement>) => {
    setCartOpen(true);
  }

  const fontStyle = {} as React.CSSProperties;
  if (config.general?.fonts?.title) {
    fontStyle['fontFamily'] = config.general.fonts.title;
  }

  // Logo sizing/position is intentionally NOT driven by per-tenant config —
  // we always show the Back Room logo. We override here because
  // `.business-title img { height: 40px }` in public/css/.../header.css has
  // the same specificity as `.header-logo img { height: 96px }` and wins by
  // source order; inline style trumps both.
  //
  // Both dimensions are constrained because the source PNG is wider than
  // tall — setting only `height` lets the width balloon past the circle.
  // `object-fit: contain` preserves aspect ratio (so the logo doesn't get
  // squashed) and fits inside the 96×96 square inscribed in the 100×100
  // circle border.
  const logoStyle: React.CSSProperties = {
    width: 96,
    height: 96,
    objectFit: 'contain',
    position: 'relative',
    left: 2.3,
    top: 2.3,
  };

  return (
    <div className="header-grow">
      <div className="header-logo">
        <Link to='/' className='business-title business-name'>
          <img style={logoStyle} alt={BRAND_NAME} src={'https://thequeensflorist.sirv.com/' + BRAND_LOGO_ROOT + '/logos/icon-small.png'}/>
        </Link>
      </div>
      <Suspense fallback={<div>Loading...</div>}>
        <AppBar position="static">
          <Toolbar className='header-toolbar'>
            <div className="header-title">
              <div>
              <Link to='/' className='business-title business-name' style={fontStyle}>
                  {BRAND_NAME}
              </Link>
              </div>
            </div>
            <SearchField display='desktop'/>
            <div className="header-section-desktop">
              <SignInButton />
              <OpenCartButton onClick={openCartDrawer}/>
            </div>
            <div className="header-section-mobile">
              <SignInButton />
              <OpenCartButton onClick={openCartDrawer}/>
            </div>
          </Toolbar>
        </AppBar>
      </Suspense>
    </div>
  );
}
